import styled from "styled-components";

const InfoArticleStyles = styled.div`
  .interview-line {
    content: "";
    border-bottom: 1px solid var(--off-black);
    height: 2px;
    width: 50px;
    margin: 40px 0;
  }

  .info-article {
    &__interview-intro {
      width: 740px;
      background: var(--ts-tan);
      transform: translateX(-40px);
      padding: 40px 40px 20px;
      margin-bottom: 40px;
    }

    &__container {
      max-width: 700px;
      margin: 0 auto;
      padding: 0 20px;
    }

    &__photo {
      width: 100%;
      max-height: 450px;
      margin-top: 60px;

      &--lower {
        width: 100%;
        max-height: 450px;
        margin-top: 10px;
      }

      &-caption {
        font-size: 14px;
        line-height: 18px;
        color: var(--medium-gray);
        margin-bottom: 40px;
      }
    }

    &__body-copy {
      line-height: 28px;
      margin-bottom: 22px;
    }
  }

  @media only screen and (max-width: 940px) {
    .info-article {
      &__interview-intro {
        width: calc(75vw + 80px);
        transform: translateX(-40px);
      }

      &__container {
        max-width: none;
        width: 75vw;
        padding: 0;
      }
      &__photo {
        margin-top: 40px;
      }
    }
  }

  @media only screen and (max-width: 700px) {
    .info-article {
      &__interview-intro {
        width: 100vw;
        padding: 40px 5vw 20px;
        transform: translateX(-5vw);
      }

      &__container {
        max-width: none;
        width: 90vw;
      }
      &__photo {
        margin-top: 20px;
      }
    }
  }
`;

export default InfoArticleStyles;
